import { Box, Flex, Title, Text, Image, Group } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import { primaryColor, ForeColorPurple } from '../../lib/constants';
import { useWindowScroll, useMediaQuery } from '@mantine/hooks';

function ChooseTheRemittance() {
  const services = [
    {
      title: 'Hotel Management & Operations',
      description:
        'Management of a diverse portfolio of hotel brands from economy to luxury, ensuring service excellence and operational efficiency across all properties.',
      image: 'img/sogo.png',
    },
    {
      title: 'Real Estate Development',
      description:
        'Strategic development and enhancement of lodging facilities, transforming properties into prime hospitality destinations.',
      image: 'img/sogo.png',
      // linkText: 'Click here to find a branch near you.',
      // linkUrl: 'https://www.ussc.com.ph.branches',
    },
    {
      title: 'Site Acquisition & Investment',
      description:
        'Identifying and acquiring strategic locations for hotel expansion and investment opportunities to strengthen affiliate growth.',
      image: 'img/sogo.png',
    },
  ];

  const conveyorImages = [
    '/img/services/img-carousel1.png',
    '/img/services/img-carousel2.jpg',
    '/img/services/img-carousel3.png',
    '/img/services/img-carousel4.png',
    '/img/services/img-carousel5.png',
  ];

  const [visibleCards, setVisibleCards] = useState(services.map(() => false));
  const cardRefs = useRef([]);
  const isMobile = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    cardRefs.current = cardRefs.current.slice(0, services.length); // align refs to items

    const observers = cardRefs.current.map((ref, i) => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setVisibleCards((prev) => {
              const updated = [...prev];
              updated[i] = true;
              return updated;
            });
            observer.disconnect();
          }
        },
        { threshold: 0.3 }
      );

      if (ref) observer.observe(ref);
      return observer;
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, [services.length]);

  return (
    <Box id="chooseRemit" className="chooseRemit" mt={isMobile ? "80px" : "150px"}>
      {/* Section Title */}
      <Title
        mx={isMobile ? "5%" : "15%"}
        my={50}
        style={{
          textAlign: 'center',
          fontWeight: 400,
          color: '#323232',
          fontSize: isMobile ? 28 : 36,
        }}
      >
        Our Services
      </Title>

      {/* Services Cards */}
      <Flex
          w="100%"
          h="auto"
          direction={isMobile ? "column" : "row"}
          justify="center"
          align="stretch"
          gap={isMobile ? "20px" : "50px"}
          px={isMobile ? "20px" : 0}
        >
        {services.map((service, i) => (
          <Box
            key={i}
            ref={(el) => (cardRefs.current[i] = el)}
            className={`${visibleCards[i] ? 'fade-text delay-' + i : 'text-hidden'}`}
            bg={ForeColorPurple}
            w={isMobile ? "100%" : "400px"}
            p={isMobile ? 30 : 60}
          >
            <Group>
              <Text pr={isMobile ? 0 : 80} mt={10} style={{ fontWeight: 400, color: primaryColor, fontSize: isMobile ? 22 : 28 }}>
                {service.title}
              </Text>
              <Text mt={isMobile ? 16 : 50} style={{ fontWeight: 400, color: primaryColor, fontSize: 18 }}>
                {service.description}
              </Text>
              {service.linkText && (
                <div style={{ fontWeight: 500, fontSize: '10px', color: primaryColor }}>
                  {service.linkText} <br />
                  <a href={service.linkUrl} style={{ color: primaryColor, textDecoration: 'none' }}>
                    any.com
                  </a>
                </div>
              )}
            </Group>
          </Box>
        ))}
      </Flex>

      {/* Conveyor Strip */}
      <Box
        style={{
          overflow: 'hidden',
          width: isMobile ? '100%' : '60%',
          height: '160px',
          position: 'relative',
          margin: '100px auto',
        }}
      >
        <Box
          className="scroll-strip"
          style={{
            display: 'flex',
            animation: 'scroll-left 25s linear infinite',
            whiteSpace: 'nowrap',
          }}
        >
          {[...conveyorImages, ...conveyorImages].map((src, i) => (
            <Box
              key={i}
              style={{
                width: '200px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '0 7%',
                flexShrink: 0,
              }}
            >
              <Image
                src={src}
                style={{
                  width: '150px',
                  height: 'auto',
                  objectFit: 'contain',
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>

      {/* Keyframes and Fade-in Animation */}
      <style>
        {`
          @keyframes scroll-left {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }

          .fade-text {
            opacity: 1;
            transform: translateY(0);
            transition: opacity 0.8s ease-out, transform 0.8s ease-out;
          }

          .text-hidden {
            opacity: 0;
            transform: translateY(30px);
          }

          .delay-0 { transition-delay: 0.1s; }
          .delay-1 { transition-delay: 0.3s; }
          .delay-2 { transition-delay: 0.5s; }
        `}
      </style>
    </Box>
  );
}

export default ChooseTheRemittance;
